import angular from "angular";

angular
    .module('app')
    .component('activeGroupsControl', {
        template: require('./active-groups-control.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {

        }
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.getGroupsList();
    };

    $ctrl.getGroupsList = function () {
        $http
            .get('active-groups-students/get-groups-list')
            .then(
                function (response) {
                    $ctrl.groups = response.data;
                },
                function (error) {

                }
            );
    };
}
